(ns pfo.category.core
  (:require [pfo.category.component :as component]
            [pfo.util :as util]))

(defn category-list [{:keys [query-params]}]
  (util/set-page #'component/category-list))
